var e=function(e){return(""+e).split(/(?=[A-Z])/).join("-").toLowerCase().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")};export{e as s};
//# sourceMappingURL=slugify.js.map
